import { define, refine, unknown } from 'superstruct';

export const Url = define('Url', (value): boolean => {
  if (!value) {
    return true;
  }
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
  return urlRegex.test(value as string);
});

export const DomElement = refine(unknown(), 'DomElement', (value) => {
  return typeof value === 'string' || value instanceof HTMLElement;
});
